import { render, staticRenderFns } from "./MultipleSheetsXlsxDownload.vue?vue&type=template&id=48287fbb&scoped=true"
import script from "./MultipleSheetsXlsxDownload.vue?vue&type=script&lang=js"
export * from "./MultipleSheetsXlsxDownload.vue?vue&type=script&lang=js"
import style0 from "./MultipleSheetsXlsxDownload.vue?vue&type=style&index=0&id=48287fbb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48287fbb",
  null
  
)

export default component.exports